import EquipmentManagePane from "./EquipmentManagePane";

export default EquipmentManagePane;
export { EquipmentManagePane };
